import { Button, ControlGroup, FormGroup, HTMLInputProps, Icon, IInputGroupProps, InputGroup, Tooltip } from "@blueprintjs/core";
import { IFieldProps, IWidgetProps } from "decorator-form";
import React from "react";

import { FlexJustify } from "common/fragments/Flex";
import StringUtil from "core/util/StringUtil";

export interface ITextWidgetProps extends IWidgetProps<string> {
	fill?: boolean;
	placeholder?: string;
	requireConfirm?: boolean; // do onChange on confirm button click
}

export default class TextWidget extends React.PureComponent<ITextWidgetProps, { value: string }> {

	public constructor(props: ITextWidgetProps) {
		super(props);
		this.state = { value: props.value || "" };
	}

	public render() {

		const { value, onChange, required, disabled, placeholder, fill = true, requireConfirm } = this.props;

		const inputProps: IInputGroupProps & HTMLInputProps = { disabled, placeholder, required };

		if (requireConfirm) {
			inputProps.value = this.state.value;
			inputProps.onChange = this.onChange;

			if (this.state.value && this.state.value !== value) {
				inputProps.rightElement = (
					<Tooltip content="Confirm Change">
						<Button
							intent="success"
							minimal={true}
							icon="confirm"
							onClick={this.onConfirm}
						/>
					</Tooltip>
				);
			}
		} else {
			inputProps.defaultValue = value;
			inputProps.onBlur = this.onBlur;
		}

		return (
			<ControlGroup fill={fill}>
				<InputGroup {...inputProps} />
			</ControlGroup>
		);
	}

	private onChange = (e: any) => this.setState({value: e.target.value});

	private onBlur = (e: any) => this.props.onChange(e.target.value);

	private onConfirm = () => this.props.onChange(this.state.value);
}



// WEBPACK FOOTER //
// ./src/common/form/widgets/TextWidget.tsx